import styled from "styled-components";
import { StyledFlexColumn } from "../../../../../styles/LayoutStyles";

export const StyledFieldMapping = styled(StyledFlexColumn)`
  gap: ${(props) => props.theme.spacing.small};
`;

export const StyledFixedValue = styled.p`
  background-color: ${(props) => props.theme.colors.primary.lightest};
  border-radius: ${(props) => props.theme.radius.normal};
  padding: ${(props) => props.theme.spacing.normal};
  border: 1px solid transparent;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;
